import Grid from '@mui/material/Grid';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { getLocale } from '../../selectors/router';
import { getAsset } from '../../lib/settings';
import { path } from 'ramda';
import { useSelector } from 'react-redux';
import Link from '@mui/material/Link';

const useStyles = makeStyles((theme) => ({
  bar: {
    padding: '0 10vw',
    background: '#f1f1f1',
    display: 'grid',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
    maxHeight: '5rem',
  },
  barText: {
    padding: '5px 10px',
    background: '#f1f1f1',
    fontSize: '0.8rem',
    maxWidth: '100%',
  },
  licenseText: {
    padding: '5px 5px',
    background: '#f1f1f1',
    fontSize: '0.5rem',
    maxWidth: '100%',
  },
  img: {
    maxHeight: '20px',
    padding: '5px 10px',
    verticalAlign: 'middle',
  },
  ubaImg: {
    maxHeight: '45px',
    paddingTop: '10px',
    verticalAlign: 'middle',
    boxSizing: 'initial',
  },
  footer: {
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
    },
    bottom: 0,
    width: '100%',
    zIndex: 1,
  },
}));

const privacyLink = (localId) => {
  return (
    <Link underline="hover" color="primary" href="/privacy">
      <FormattedMessage
        id="de.uba.footer.privacy_statement"
        defaultMessage={
          localId === 'en' ? 'Privacy statement' : 'Datenschutzerklärung'
        }
      />
    </Link>
  );
};

const imprintLink = (localId) => {
  return (
    <Link underline="hover" color="primary" href="/impressum">
      <FormattedMessage
        id="de.uba.footer.imprint"
        defaultMessage={localId === 'en' ? 'Imprint' : 'Impressum'}
      />
    </Link>
  );
};

const accessibility = (localId) => {
  return (
    <Link underline="hover" color="primary" href="/accesibility">
      <FormattedMessage
        id="de.uba.footer.accessibility"
        defaultMessage={
          localId === 'en' ? 'Accessibility' : 'Erklärung zur Barrierefreiheit'
        }
      />
    </Link>
  );
};

const feedback = (localId) => {
  return (
    <Link underline="hover" color="primary" href="/impressum">
      <FormattedMessage
        id="de.uba.footer.feedback"
        defaultMessage={localId === 'en' ? 'Feedback' : 'Feedback'}
      />
    </Link>
  );
};

const UbaFooter = () => {
  const classes = useStyles();
  const localeId = useSelector(getLocale);
  const logo = getAsset('footer', localeId);
  const ubaLogo = getAsset('viewerFooter', localeId);
  return (
    <Fragment>
      <div className={classes.footer} id="uba-footer">
        <Grid
          className={classes.bar}
          direction="row"
          container
          justifyContent="flex-start"
          alignItems="start"
        >
          <Grid>
            <div className={classes.logoWrapper}>
              <Link underline="hover" color="primary" href="/">
                <img
                  className={classes.ubaImg}
                  src={ubaLogo}
                  alt="siscc logo"
                />
              </Link>
            </div>
          </Grid>
          <Grid>
            <Grid className={classes.barText} item xs={12} sm="auto">
              {privacyLink(localeId)}
            </Grid>
            <Grid className={classes.barText} item xs={12} sm="auto">
              {imprintLink(localeId)}
            </Grid>
          </Grid>
          <Grid>
            <Grid className={classes.barText} item xs={12} sm="auto">
              {accessibility(localeId)}
            </Grid>
            <Grid className={classes.barText} item xs={12} sm="auto">
              {feedback(localeId)}
            </Grid>
          </Grid>
          <Grid>
            <Grid
              className={classes.licenseText}
              item
              container
              xs="auto"
              sm={8}
            >
              <FormattedMessage id="de.footer.disclaimer" />
              <a href="https://sis-cc.gitlab.io/dotstatsuite-documentation/about/license/">
                <FormattedMessage id="de.uba.footer.statsuite.license" />
              </a>
              .
            </Grid>
            <Grid className={classes.licenseText} item xs="auto" sm={4}>
              <FormattedMessage
                id="de.footer.description"
                values={{
                  icon: <img className={classes.img} src={logo} alt="icon" />,
                  link: (
                    <Link
                      underline="hover"
                      color="primary"
                      href={path(['app', 'footer', 'link'], window.SETTINGS)}
                    >
                      <FormattedMessage id="de.footer.author" />
                    </Link>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default UbaFooter;
